import { Injectable, Inject, Optional } from '@angular/core';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';
import { DOCUMENT } from '@angular/common';
import { LocalStorageService } from './local-storage.service';
import { BROWSER_WINDOW } from '../injection-tokens/browser-window';

@Injectable({
  providedIn: 'root'
})
export class MouseflowService {
  injected = false;
  private storageHandle = 'unpushedExperimentsMouseflow';
  private unpushedExperiments = this.localStorageService.get<Array<{ id: string; variant: string }>>(
    this.storageHandle,
    []
  );

  constructor(
    @Optional() @Inject(BROWSER_WINDOW) private window,
    @Optional() @Inject(DOCUMENT) private document,
    private platformService: PlatformInformationService,
    private localStorageService: LocalStorageService
  ) {}

  /**
   * @param experimentId the experiment id from optimize backend
   * @param variant the variant starting with 0 for regular, 1 for variant 1, ...
   */
  activateExperiment(experimentId: string, variant: string) {
    try {
      if (this.window && typeof this.window._mfq !== 'undefined') {
        this.window._mfq.push(['setVariable', experimentId, variant]);
        this.window._mfq.push(['tag', experimentId]);
      } else {
        this.unpushedExperiments.push({ id: experimentId, variant: variant });
        this.localStorageService.set(this.storageHandle, this.unpushedExperiments);
      }
    } catch (error) {
      console.error(error);
    }
  }

  injectMouseflow() {
    if (!this.injected) {
      this.injected = true;
      if (this.platformService.isLiveProd()) {
        const node = this.document.createElement('script');
        node.type = 'text/javascript';
        node.defer = true;
        node.async = true;
        node.src = `https://cdn.mouseflow.com/projects/ef2c0917-d3df-4431-9ef1-2bc1ebff6c3f.js`;
        node.onload = () => {
          this.unpushedExperiments.forEach(experiment => {
            this.activateExperiment(experiment.id, experiment.variant);
          });
          this.unpushedExperiments = [];
          this.localStorageService.remove(this.storageHandle);
        };

        const head = this.document.getElementsByTagName('head')[0];
        head.insertBefore(node, head.firstChild);
      }
    }
  }
}
